function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2066",
  "data-name": "Group 2066",
  transform: "translate(-810 -441)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_ionic-ios-list",
  "data-name": "Icon ionic-ios-list",
  transform: "translate(810 441)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_226",
  "data-name": "Path 226",
  d: "M12.9,20.229a4.2,4.2,0,1,1-4.2-4.2A4.2,4.2,0,0,1,12.9,20.229Z",
  transform: "translate(-4.5 2.558)",
  fill: "#cbcbcb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_227",
  "data-name": "Path 227",
  d: "M12.9,11.51a4.2,4.2,0,1,1-4.2-4.2A4.2,4.2,0,0,1,12.9,11.51Z",
  transform: "translate(-4.5 -7.313)",
  fill: "#cbcbcb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_228",
  "data-name": "Path 228",
  d: "M12.9,28.948a4.2,4.2,0,1,1-4.2-4.2,4.2,4.2,0,0,1,4.2,4.2Z",
  transform: "translate(-4.5 12.428)",
  fill: "#cbcbcb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_229",
  "data-name": "Path 229",
  d: "M50.792,16.875H14.738a2.4,2.4,0,1,0,0,4.8H50.792a2.4,2.4,0,0,0,0-4.8Z",
  transform: "translate(4.375 3.513)",
  fill: "#cbcbcb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_230",
  "data-name": "Path 230",
  d: "M50.792,25.594H14.738a2.4,2.4,0,1,0,0,4.8H50.792a2.4,2.4,0,0,0,0-4.8Z",
  transform: "translate(4.375 13.383)",
  fill: "#cbcbcb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_231",
  "data-name": "Path 231",
  d: "M14.738,12.953H50.792a2.4,2.4,0,0,0,0-4.8H14.738a2.4,2.4,0,0,0,0,4.8Z",
  transform: "translate(4.375 -6.357)",
  fill: "#cbcbcb"
})), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_24",
  "data-name": "Ellipse 24",
  cx: 18.061,
  cy: 18.592,
  rx: 18.061,
  ry: 18.592,
  transform: "translate(847.228 452.264)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon_ionic-md-close-circle-outline",
  "data-name": "Icon ionic-md-close-circle-outline",
  transform: "translate(852.625 450.396)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_555",
  "data-name": "Path 555",
  d: "M19.776,6.687a13.084,13.084,0,1,1-9.257,3.832,13.035,13.035,0,0,1,9.257-3.832m0-3.312a16.4,16.4,0,1,0,16.4,16.4,16.4,16.4,0,0,0-16.4-16.4Z",
  fill: "#cbcbcb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_556",
  "data-name": "Path 556",
  d: "M27.088,24.794l-2.295,2.295-5.906-5.906-5.906,5.906-2.295-2.295,5.906-5.906-5.906-5.906,2.295-2.295,5.906,5.906,5.906-5.906,2.295,2.295-5.906,5.906Z",
  transform: "translate(0.888 0.888)",
  fill: "#cbcbcb"
})));

function SvgNoMatchFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.802,
    height: 48.448,
    viewBox: "0 0 78.802 48.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMatchFound);
export default __webpack_public_path__ + "static/media/noMatchFound.241ffbe55988560184ae7d40caf14a32.svg";
export { ForwardRef as ReactComponent };